import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchShowcaseFilterEntity } from '../../domain/entities/BranchShowcaseFilterEntity'

export class BranchShowcaseFilterModel extends BranchShowcaseFilterEntity {
  serviceId?: number
  branchId?: number
  
  constructor(dataDto: BranchShowcaseFilterEntity) {
    super()
    mapEntityProperties<BranchShowcaseFilterModel>(this, dataDto, {
      exclude: ['service' , 'branch'],
      map: {
          serviceId: dataDto.service?.id,
          branchId:dataDto.branch?.id
      }
    })
  }
}